import { UserTockem } from "../../Utils/autenticacao";
import axios from "axios";
import { urlBase } from "../../Constante/Url";

const getConfig = (params) => {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };
};

const getProcedure = async (page, pageSize, params) => {
  let skip = (page - 1) * pageSize;
  const url = `${urlBase}Procedure/?limit=${pageSize}&offset=${skip}`;
  const config = getConfig(params);
  const response = await axios.get(url, config);
  return response;
};
const getProcuredId = async (id) => {
  const url = `${urlBase}Procedure/${id}/`;
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
};

const postProcedure = async (data, id) => {
  const url = id ? `${urlBase}Procedure/${id}/` : `${urlBase}Procedure/`;
  const config = getConfig();
  let response;
  if (id) {
    response = await axios.put(url, data, config);
  } else {
    response = await axios.post(url, data, config); 
  }
  
  return response;
};

const putProcedure = async (id, data) => {
  const url = `${urlBase}Procedure/${id}/`;
  const config = getConfig();
  const response = await axios.put(url, data, config);
  return response;
};

const deleteProcedure = async (id) => {
  const url = `${urlBase}Procedure/${id}/`;
  const config = getConfig();
  const response = await axios.delete(url, config);
  return response;
};

export const procedureRequest = {
  getProcedure,
  getProcuredId,
  postProcedure,
  putProcedure,
  deleteProcedure,
};
